module.exports = __webpack_public_path__ + "img/7.3cb2364a.png";